// Pre-baked starter templates exposed via the Library "New from template"
// dropdown. Each entry produces a fully-formed InputDefinition payload — we
// POST it to /input-definition and let the existing create flow assign id +
// timestamps + user_id.
//
// Keep these small and representative. They're meant as starting points users
// will rename and tweak, not as production-ready definitions.

export const STARTER_TEMPLATES = [
  {
    key: "mfalite-basic",
    title: "MFAlite — Basic (1 condition)",
    description: "Single condition, single replicate, default timepoints.",
    payload: {
      name: "MFAlite Basic",
      description: "Starter: single-condition MFAlite study",
      status: "draft",
      product: "MFAlite",
      analysis_types: [],
      experimental_conditions: {
        "Condition_1": {
          name: "Condition_1",
          description: "",
          replicates: 1,
          timepoints: [0, 3, 5, 7, 10, 14],
        },
      },
      time_points: { "Condition_1": [0, 3, 5, 7, 10, 14] },
      desired_output_summary:
        "Baseline metabolic-flux estimates for a single condition.",
      desired_outputs: ["metabolite concentrations", "IgG titer"],
    },
  },
  {
    key: "mfalite-amino-acids",
    title: "MFAlite — With amino acids",
    description: "Single condition + amino-acid data sheet.",
    payload: {
      name: "MFAlite with Amino Acids",
      description: "Starter: amino-acid profiling alongside core flux",
      status: "draft",
      product: "MFAlite",
      analysis_types: ["amino_acid_data"],
      experimental_conditions: {
        "Condition_1": {
          name: "Condition_1",
          description: "",
          replicates: 2,
          timepoints: [0, 3, 7, 14],
        },
      },
      time_points: { "Condition_1": [0, 3, 7, 14] },
      desired_output_summary:
        "Flux estimates with amino-acid uptake/secretion profiles.",
      desired_outputs: [
        "metabolite concentrations",
        "amino acid profiles",
        "IgG titer",
      ],
    },
  },
  {
    key: "cloneselect-multi",
    title: "CloneSelectMFA — Multi-clone (4 conditions)",
    description: "Four conditions sharing common timepoints, single replicate each.",
    payload: {
      name: "CloneSelectMFA — Clone Screen",
      description: "Starter: comparative flux analysis across 4 clones",
      status: "draft",
      product: "CloneSelectMFA",
      analysis_types: [],
      experimental_conditions: Object.fromEntries(
        ["Clone_A", "Clone_B", "Clone_C", "Clone_D"].map((name) => [
          name,
          { name, description: "", replicates: 1, timepoints: [0, 3, 7, 10, 14] },
        ])
      ),
      time_points: Object.fromEntries(
        ["Clone_A", "Clone_B", "Clone_C", "Clone_D"].map((n) => [n, [0, 3, 7, 10, 14]])
      ),
      desired_output_summary:
        "Comparative flux rankings across the candidate clones.",
      desired_outputs: ["metabolite concentrations", "IgG titer"],
    },
  },
  {
    key: "perfuse-continuous",
    title: "PerfuseMFA — Continuous (2 conditions)",
    description: "Perfusion-enabled, two conditions, extended timepoints.",
    payload: {
      name: "PerfuseMFA Continuous",
      description: "Starter: continuous-perfusion flux analysis",
      status: "draft",
      product: "PerfuseMFA",
      analysis_types: ["amino_acid_data"],
      experimental_conditions: {
        "Continuous_A": {
          name: "Continuous_A",
          description: "Control feed",
          replicates: 1,
          timepoints: [0, 5, 10, 15, 20, 25, 30],
        },
        "Continuous_B": {
          name: "Continuous_B",
          description: "Enriched feed",
          replicates: 1,
          timepoints: [0, 5, 10, 15, 20, 25, 30],
        },
      },
      time_points: {
        "Continuous_A": [0, 5, 10, 15, 20, 25, 30],
        "Continuous_B": [0, 5, 10, 15, 20, 25, 30],
      },
      desired_output_summary:
        "Steady-state flux estimates across perfusion conditions.",
      desired_outputs: [
        "metabolite concentrations",
        "amino acid profiles",
        "IgG titer",
        "process parameters",
      ],
    },
  },
];
